module.exports = __webpack_public_path__ + "img/1.e55c78d7.jpg";